<template>
    <OnClickOutside @click="$emit('dismiss')">
        <div ref="content" :class="isVisible ? 'd-block' : 'd-none'">
            <LogsTable :logs="logs" :is-loading="isLoading" />
        </div>
    </OnClickOutside>
</template>

<script>
import LogsTable from '@/js/components/log/LogsTable';
import OnClickOutside from '@/js/components/dom/OnClickOutside';

const TEMPLATE = '<div class="popover log-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';

export default {
    name: 'LogPreview',

    components: {OnClickOutside, LogsTable},

    props: {
        logs: {type: Array, required: true},
        title: {type: String, default: null},
        target: {type: String, required: true},
        isLoading: {type: Boolean},
    },

    data() {
        return {
            isVisible: false,
        };
    },

    mounted() {
        const $target = window.jQuery(`#${this.target}`);
        const $content = window.jQuery(this.$refs.content);

        $target.popover({
            container: 'body',
            placement: 'auto',
            content: () => $content,
            html: true,
            sanitize: false,
            trigger: 'focus',
            template: TEMPLATE,
        });

        $target.popover('show');

        this.$nextTick(() => {
            this.isVisible = true;
            this.fixTitle($content);
        });

        $target.on('hidden.bs.popover', () => {
            this.$emit('dismiss');
        });

        this.$once('hook:beforeDestroy', () => {
            $target.off();
            $target.popover('dispose');
        });
    },

    methods: {
        fixTitle($content) {
            const $header = $content.closest('.popover').find('.popover-header');

            if (!$header) {
                return;
            }

            $header.empty().append(this.title || this.$t('logs.recent'));
        },
    },
};
</script>

<style>
.popover.log-popover {
    display: none !important;
}

@media screen and (min-width: 960px) {
    .popover.log-popover {
        display: block !important;

        width: 80vw;
        max-width: 80vw !important;

        height: 250px !important;
        max-height: 250px !important;
    }

    .popover.log-popover .table-responsive {
        overflow-x: hidden;
        overflow-y: auto;

        max-height: 200px;
    }
}

@media screen and (min-width: 1200px) {
    .popover.log-popover {
        width: 50vw;
    }
}
</style>
